/** @public */
export type Comparable = number | string;

export type Sort<TItem> =
    | {
          by: (item: TItem) => Comparable | null;
          ord: "asc" | "desc";
      }
    | { by: (item: TItem) => Comparable | null; ord: "asc" | "desc" }[];

function createSort<T>(cmp: (a: T, b: T) => number) {
    return function (a: Iterable<T>, b: Iterable<T>) {
        const iterA = a[Symbol.iterator]();
        const iterB = b[Symbol.iterator]();

        while (true) {
            const na = iterA.next();
            const nb = iterB.next();

            if (na.done) return nb.done ? 0 : -1;
            if (nb.done) return 1;

            const result = cmp(na.value, nb.value);
            if (result != 0) return result;
        }
    };
}

const cmpAsMongoDb = createSort((a: string, b: string) => {
    return a < b ? -1 : a > b ? 1 : 0;
});

export function createCmp<T extends { id: string }>(sort: Sort<T>) {
    return function (itemA: T, itemB: T): number {
        for (const each of [sort].flat()) {
            const dir = each.ord == "asc" ? 1 : -1;

            const a = each.by(itemA);
            const b = each.by(itemB);

            if (a != null && b == null) {
                return 1;
            }

            if (a == null && b != null) {
                return -1;
            }

            if (typeof a == "string" && typeof b == "string") {
                const result = cmpAsMongoDb(a, b);
                if (result != 0) return dir * result;
            }

            if (typeof a == "number" && typeof b == "number") {
                if (a != b) {
                    const result = dir * (a - b);
                    return result > 1 ? 1 : result < -1 ? -1 : 0;
                }
            }
        }

        return -1 * cmpAsMongoDb(itemA.id, itemB.id); // default to _id DESC
    };
}
